/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Pressable, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { ConversationAction } from '@atlassian/rovo-conversation-actions';

const styles = cssMap({
	actionItemWrapperStyles: {
		width: '24px',
		height: '24px',
		flexShrink: 0,
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		// @ts-expect-error
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& svg': {
			color: token('color.icon.inverse'),
		},
	},
	actionButtonPressable: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.100'),
		backgroundColor: token('color.background.neutral.bold'),
		borderTopLeftRadius: token('radius.xxlarge'),
		borderTopRightRadius: token('radius.xxlarge'),
		borderBottomLeftRadius: token('radius.xxlarge'),
		borderBottomRightRadius: token('radius.large'),
		paddingTop: token('space.150'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.200'),
		cursor: 'pointer',
		minHeight: '48px',
		whiteSpace: 'nowrap',
		// @ts-expect-error
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		boxShadow: '0 0 1px 0 rgba(30, 31, 33, 0.31), 0 8px 12px 0 rgba(30, 31, 33, 0.15)',
		'&:hover': {
			transform: 'scale(1.025)',
			transition: 'transform 0.1s ease-in-out',
			cursor: 'pointer',
		},
	},
});

type AIActionShortcutProps = {
	action: ConversationAction;
	onActionClick: (action: ConversationAction) => void;
};

export const AIActionShortcut = ({ action, onActionClick }: AIActionShortcutProps) => {
	const Icon = action.icon;
	return (
		<Box key={action.id}>
			<Pressable
				testId="action-shortcut-icon-and-text"
				xcss={styles.actionButtonPressable}
				onClick={() => onActionClick(action)}
			>
				<Box xcss={styles.actionItemWrapperStyles}>
					<Icon label="" primaryColor={token('color.icon.inverse')} />
				</Box>

				<Text color="color.text.inverse" size="small" weight="medium">
					{action.title}
				</Text>
			</Pressable>
		</Box>
	);
};
